export const zodSchemaForType = () => (schema) => {
    return schema;
};
